var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoYoutube22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H18C20.2091 0 22 1.79086 22 4V18C22 20.2091 20.2091 22 18 22H4C1.79086 22 0 20.2091 0 18V4Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1485 6.22274C18.3967 6.47258 18.575 6.78325 18.6655 7.12364C19 8.38 19 11 19 11C19 11 19 13.62 18.6655 14.8764C18.575 15.2168 18.3967 15.5274 18.1485 15.7773C17.9002 16.0271 17.5907 16.2074 17.2509 16.3C16 16.6364 11 16.6364 11 16.6364C11 16.6364 6 16.6364 4.74909 16.3C4.40929 16.2074 4.09977 16.0271 3.85153 15.7773C3.60328 15.5274 3.425 15.2168 3.33455 14.8764C3 13.62 3 11 3 11C3 11 3 8.38 3.33455 7.12364C3.425 6.78325 3.60328 6.47258 3.85153 6.22274C4.09977 5.9729 4.40929 5.79264 4.74909 5.7C6 5.36364 11 5.36364 11 5.36364C11 5.36364 16 5.36364 17.2509 5.7C17.5907 5.79264 17.9002 5.9729 18.1485 6.22274ZM13.5455 11L9.36365 8.62093V13.3791L13.5455 11Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYoutube22);
export default __webpack_public_path__ + "static/media/logo-youtube-22.2b8dd3cf45064c769bbaaa3af6f4ada4.svg";
export { ForwardRef as ReactComponent };